import { render } from "./mostafeed.vue?vue&type=template&id=5b727c2f&scoped=true"
import script from "./mostafeed.vue?vue&type=script&lang=js"
export * from "./mostafeed.vue?vue&type=script&lang=js"

import "./mostafeed.vue?vue&type=style&index=0&id=5b727c2f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b727c2f"]])

export default __exports__